import { gql } from '@apollo/client'
export const ImportFileUploadMutation = gql`
    mutation importProjectProductFamily(
        $input: ImportProjectProductFamilyInput!
    ) {
        importProjectProductFamily(input: $input) {
            instanceId
        }
    }
`

export const ImportDiscardFileMutation = gql`
    mutation discardFileForImport($input: DiscardImportProjectFamilyInput!) {
        discardFileForImport(input: $input) {
            firmId
            errorMessage
            key
        }
    }
`
export const BPImportDeleteImportedFamilyMutation = gql`
    mutation deleteImportedFamily($input: DeleteImportedFamilyInput!) {
        deleteImportedFamily(input: $input)
    }
`
export const GetDuplicateFileMutation = gql`
    mutation getDuplicateProjectProductFamily(
        $input: ImportProjectProductFamilyInput!
    ) {
        getDuplicateProjectProductFamily(input: $input) {
            instanceId
            errorMessage
        }
    }
`
export const RenameImportedFamilyName = gql`
    mutation renameImportedFamily($input: UpdateImportedFamilyNameInput!) {
        renameImportedFamily(input: $input) {
            status
            importDetails {
                fileKey
                title
                productTypeCount
                productTypeInfo {
                    name
                    propertiesCount
                }
                propertiesCount
                errors
                warnings
                familyId
                backConvertedDiffDocxUri
            }
        }
    }
`
export const GetProjectProductFamilyPreviewMutation = gql`
    mutation getProjectProductFamilyPreview(
        $input: ProjectProductFamilyFileInput!
    ) {
        getProjectProductFamilyPreview(input: $input) {
            instanceId
            errorMessage
        }
    }
`
export const GetProjectProductTypePreviewMutation = gql`
    mutation getProductTypePreview(
        $input: UserImportedFamilyProductTypeInput!
    ) {
        getProductTypePreview(input: $input) {
            instanceId
            errorMessage
        }
    }
`
export const ExecuteImportProjectProductFamily = gql`
    mutation executeImportProjectProductFamily(
        $input: ImportProjectProductFamilyInput!
    ) {
        executeImportProjectProductFamily(input: $input) {
            importInstanceId
        }
    }
`
